<script lang="ts" setup>
import { closeModal as pluginCloseModal } from 'jenesius-vue-modal'

interface Props {
  nameModal: string
  disableTeleport?: boolean
  width?: number
  maxWidth?: number
}

const props = withDefaults(defineProps<Props>(), {
  nameModal: 'templateModal',
  disableTeleport: false,
  width: undefined,
  maxWidth: undefined,
})
const emit = defineEmits<{
  (e: 'close'): void
}>()

const slots = useSlots()

const modalWidth = computed(() => {
  return props.width === undefined ? '' : ('width: ' + props.width + 'px; ')
})

const modalMaxWidth = computed(() => {
  return props.maxWidth === undefined ? '' : ('max-width: ' + props.maxWidth + 'px; ')
})

const refModal: Ref = ref(null)

const closeModal = () => {
  pluginCloseModal()
  emit('close')
}

defineExpose({
  closeModal,
})

</script>

<template>
  <div
    class="modal fade show active prevent_unselection"
    tabindex="-1"
    ref="refModal"
    aria-hidden="true"
    data-backdrop="static"
    :style="'display: block; ' + modalWidth"
    :id="nameModal"
    :aria-labelledby="nameModal + 'Label'"
  >
    <div
      :style="modalMaxWidth"
      class="modal-dialog modal-dialog-centered"
    >
      <div
        class="modal-content"
        :style="modalWidth"
      >
        <div class="modal-header">
          <slot name="header" />
          <button
            type="button"
            class="btn-close icon-size-16"
            aria-label="Закрыть"
            @click="closeModal"
          >
            <svg
              width="16"
              height="16"
              viewBox="0 0 16 16"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <mask
                id="mask0_210_33851"
                style="mask-type:alpha"
                maskUnits="userSpaceOnUse"
                x="0"
                y="0"
                width="16"
                height="16"
              >
                <path
                  fill-rule="evenodd"
                  clip-rule="evenodd"
                  d="M8.02176 9.43677L12.0003 13.4152L13.4145 12.001L9.43599 8.02258L13.4586 4.00014L12.0443 2.58594L8.02176 6.60838L3.99919 2.58594L2.58496 4.00013L6.60752 8.02258L2.58701 12.043L4.00124 13.4572L8.02176 9.43677Z"
                  fill="black"
                />
              </mask>
              <g mask="url(#mask0_210_33851)">
                <rect
                  width="16"
                  height="16"
                  fill="black"
                  fill-opacity="0.4"
                />
              </g>
            </svg>
          </button>
        </div>
        <div class="modal-body">
          <slot name="body" />
        </div>
        <div
          v-if="slots.footer"
          class="modal-footer"
        >
          <slot name="footer" />
        </div>
      </div>
    </div>
    <div
      v-if="slots.additional"
      class="modal-additional"
    >
      <slot name="additional" />
    </div>
  </div>
</template>

<style lang="scss" scoped>

.modal {
  width: unset;
  height: unset;
  position: unset;
  max-height: calc(100dvh - 24px);
  /*overflow-x: hidden;
  overflow-y: auto;*/
  width: rem(400px);

  @include media-breakpoint-down(lg) {
    width: 100%;

    .modal-dialog {
      max-width: 100%;
    }
  }
}

.btn-close {
  border-radius: 50%;
  background: $bg-neutral;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: rem(-8px) rem(-8px) 0 0;

  @include media-breakpoint-down(lg) {
    margin: 0;
    padding: rem(4px);
  }
}

.modal-dialog {
  margin: unset;
}

.modal-content {
  border: none;
  box-shadow: 0 8px 28px rgba(0, 0, 0, .16);
  padding: rem(24px);
  border-radius: rem(24px);

  @include media-breakpoint-down(lg) {
    border: none;
    border-radius: rem(4px) rem(4px) 0 0;
    padding: rem(12px);
    padding-bottom: rem(40px);
  }

  @include media-breakpoint-down(md) {
    padding-bottom: rem(24px);
  }
}

.modal-header {
  gap: 0 rem(8px);
  align-items: flex-start;
  border-bottom: none;
  padding: 0;
}

.modal-body {
  /*min-width: rem(452px);*/
  padding: 0;
  margin-top: rem(8px);
}

.modal-footer {
  padding: 0;
  border-top: none;
  margin: rem(-4px);
  margin-top: rem(20px);

  @include media-breakpoint-down(lg) {
    border: none;
    padding: rem(20px) 0 0;
    margin: rem(-4px);
    justify-content: flex-start;
  }

  @include media-breakpoint-down(md) {
    flex-direction: column-reverse;

    :deep(.btn) {
      width: calc(100% - 8px);
    }
  }
}
</style>
